import React, { useEffect, useState } from "react";
import { Table, Spin, message, Row, Col, Button, Typography, Card } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import { DiffChecker_URL,DateTimeFormat } from "../../Components/Constant";
import dayjs from "dayjs";
import {convertDateToUserTimezone} from '../../Components/Utility';


const { Title } = Typography;
const DiffCheckerLogs = ({comparejouney}) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        fetchLogs();
    }, []);

     const fetchLogs = async () => {
            setLoading(true);
            try {
                const JWTToken = Cookies.get("tokenRes");
                const response = await axios.get(`${DiffChecker_URL}/logs/comparejourney/${comparejouney?._id}`, {
                    headers: { JWTToken },
                });
                setLogs(response.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };


    const handleDeleteAllLogs = async () => {
        try {
            const JWTToken = Cookies.get("tokenRes");
            await axios.delete(`${DiffChecker_URL}/logs/usage/${comparejouney?._id}`, {
            headers: { JWTToken },
            });
            message.success("All logs deleted successfully");
            fetchLogs(); 
        } catch (err) {
            console.error(err);
            message.error("Failed to delete logs");
        }
    };


    
    // Define table columns
    const columns = [
        {
            title: "Endpoint",
            dataIndex: "endpoint",
            key: "endpoint",
        },

        {
            title: "Status Code",
            dataIndex: "statusCode",
            key: "statusCode",
        },
         {
            title: "Timestamp",
            dataIndex: "timestamp",
            key: "timestamp",
            render: (text) => (
                    text && dayjs(text).isValid()
                    ? convertDateToUserTimezone(text, DateTimeFormat)
                    : ''
                ),        
        },
       
        {
            title: "Request Payload",
            dataIndex: "requestPayload",
            key: "requestPayload",
            render: (payload) => (
                <pre style={{ maxHeight: 200, overflow: "auto" }}>
                    {JSON.stringify(payload, null, 2)}
                </pre>
            ),
        },
        {
            title: "Response Summary",
            dataIndex: "responseSummary",
            key: "responseSummary",
            render: (summary) => (
                <pre style={{ maxHeight: 100, overflow: "auto" }}>
                    {JSON.stringify(summary, null, 2)}
                </pre>
            ),
        },
       
    ];

    return (
        <Card>
            <Row justify="space-between" align="middle" style={{ marginBottom: 5 }}>
                <Col>
                    <Title level={4} style={{ marginTop: 0 }}>
                        Logs
                    </Title>
                </Col>
                <Col>
                    <Button type="primary" danger onClick={() => handleDeleteAllLogs()}>
                        Delete All Logs
                    </Button>
                </Col>
            </Row>

            <Spin spinning={loading}>
                <Table
                    dataSource={logs}
                    columns={columns}
                    rowKey="timestamp" // or "Id" if you want
                    scroll={{ x: "max-content" }}
                />
            </Spin>
        </Card>
    );
};

export default DiffCheckerLogs;
